
export class MissingData {
  listMissingBranches: Branch[]
  listMissingAgents: Agent[]
  listMissingOffices: Office[]
  listMissingCities: City[]
  empty: boolean = true
}

export class City
{
 idCity: number 
 cityName: string
 fkIdDepartment: number
}

export class Agent
{
 idAgentKey: number
 agentName: string
 agentIdentification: string
 agentAddress: string
 agentPhone: string
 agentMail: string
 fkIdOffice: number
 modificationDate?: Date
 fkModificationUser?: number
}

export class Branch
{
 idBranch: number
  branchName: string
  branchShortName: string
}

export class Office
{
 idOffice: number
 fkIdCity: number
 officeName: string
 directorName: string
 portfolioDirectorName: string
}

export class Departaments
{
  idDepartment: number
  departmentName: string
}

export class Company {
  idConfig: number
  configKey: string
  configValue: string
}

